/**
 * Validates that a date is in the past.
 */
export const Validator = {
    name: "date_in_past",
    errorMessage: "Date must be in past.",
    validate: value => {
        const selected = new Date(`${value}`);
        const today = new Date();
        today.setHours(0, 0, 0);
        return selected < today;
    },
};
